export default "__VITE_ASSET__1bf6c2cc__"